import {Input} from '@practicegenius/pg-ui/src/base/Material/components/Input';
import * as React from 'react';

type Props = Omit<React.ComponentProps<typeof Input>, 'type'> & {
  autoFocus?: boolean;
  inputRef?: React.RefObject<HTMLInputElement>;
};

export function EmailInput(props: Props) {
  return (
    <Input
      autoCorrect="off"
      autoComplete="off"
      autoCapitalize="off"
      spellCheck={false}
      {...props}
      type="email"
    />
  );
}
